import { Components } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

type ListProps = Components<Omit<Theme, 'components'>>['MuiList'];

const getMuiList = (): ListProps => ({
  styleOverrides: {
    root: {
      '&[role="listbox"]': {
        '& > div': {
          maxHeight: '250px',
        },
      },
    },
  },
});

export default getMuiList;
